var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"tabsContainer",staticClass:"tabs",class:{ 'header-fixed': _vm.isHeaderFixed }},_vm._l((_vm.dynamicTabs),function(tab,index){return _c('li',{key:index,ref:"tabItems",refInFor:true,class:{ 'active': _vm.isActive(tab.path) },on:{"click":function($event){return _vm.goTo(tab.path)}}},[_c('a',[_vm._v(_vm._s(_vm.$t(tab.label)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }